
import constants from 'general/js/constants';
import app from 'app-instance';


export default class FormValidityHandler {
    constructor(options) {
        const {
            element, formNode, onFailed, beforeSubmit
        } = options;
        this.element = element;
        this.onFailed = onFailed;
        this.formNode = formNode;
        this.beforeSubmit = beforeSubmit;
        this._onInnerFieldValidationFailed = this._onInnerFieldValidationFailed.bind(this);


        this.element.addEventListener(constants.EVENT_FIELD_VALIDATION_FAILED, this._onInnerFieldValidationFailed);

        app.addListener('form:beforeSubmit', this._onBeforeSubmit.bind(this));
    }

    destroy() {
        this.element.removeEventListener(constants.EVENT_FIELD_VALIDATION_FAILED, this._onInnerFieldValidationFailed);
    }

    _onInnerFieldValidationFailed(e) {
        if (typeof this.onFailed === 'function') {
            this.onFailed(e);
        }
    }

    _onBeforeSubmit(formNode) {
        if (this.formNode === formNode) {
            if (typeof this.beforeSubmit === 'function') {
                this.beforeSubmit(formNode);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/form/js/form-validity-handler.js